<template>
  <BaseCard :title="'clairgreen.com'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">October 2024 - Present</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          This very website! Fully reactive and animated with 8 main pages
        </span>
        <span class="block">
          Developed in Vue.js, TypeScript, and CSS
        </span>
        <span class="block">
          Built from the ground up in my own design scheme
        </span>
        <span class="block">
          Created entirely by me! No AI whatsoever
        </span>
      </p>
      <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[50%] h-auto rounded-lg cursor-pointer" :src="WebsiteComputer" @click="openImageMenu(WebsiteComputer, 'clairgreen.com Screenshot', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import WebsiteComputer from '@/assets/Projects/WebsitePhotos/WebsiteComputer.png';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>